<div class="flex flex-col gap-3">
  <div class="flex items-center justify-between">
    <h1
      class="textPrimaryColor text-2xl font-bold"
      i18n="@@adminSidebarPartiallyDeliveredReasons">
      Partially Delivered Reasons
    </h1>

    <div *hasScope="SCOPES.PARTIALLY_DELIVERED_REASONS.CREATE">
    <a
      routerLink="/admin/partially-delivered-reasons/create-partially-delivered-reason"
      class="add-button flex items-center justify-center gap-2">

      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24">

        <path
          fill="currentColor"
          d="M18 12.998h-5v5a1 1 0 0 1-2 0v-5H6a1 1 0 0 1 0-2h5v-5a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2" />

      </svg>

      <span i18n="@@partiallyDeliveredReasonsCreate">
        Create New Reason
      </span>

    </a>
    </div>
  </div>

  <div class="mb-4 rounded-2xl pb-4">
    <app-partially-delivered-reasons-list-component>
    </app-partially-delivered-reasons-list-component>
  </div>
</div>